import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useVenueStore } from '../store/useVenueStore';

export const VenueSlider: React.FC = () => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const { venues } = useVenueStore();

  const getImageUrl = (venue: any) => {
    // Map venue IDs to their correct image filenames
    const imageMap: { [key: string]: string } = {
      'bellora': 'Bellora.webp',
      'villa-johanneberg': 'Villa.webp',
      'jacy': 'Pachanga.webp',
      'ellery': 'Ellery.webp',
      'essoess': 'rox.webp'
    };

    return `/assets/images/${imageMap[venue.id] || 'placeholder.webp'}`;
  };

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider || venues.length === 0) return;

    let position = 0;
    const animate = () => {
      if (!slider) return;
      
      position += 1;
      if (position >= slider.scrollWidth / 2) {
        position = 0;
      }
      slider.scrollLeft = position;
    };

    const animation = setInterval(animate, 30);
    return () => clearInterval(animation);
  }, [venues]);

  return (
    <div className="relative w-full bg-[#171b20] py-12">
      {/* Main container */}
      <div 
        ref={sliderRef}
        className="overflow-hidden"
      >
        {/* Slider content */}
        <div className="slider-content flex gap-6 px-20">
          {venues.map((venue) => (
            <Link
              key={venue.id}
              to={`/venues/${venue.id}`}
              className="venue-item flex-none w-[450px] group relative"
            >
              <div className="relative h-[260px] rounded-xl overflow-hidden bg-[#1a1e24]">
                <img
                  src={getImageUrl(venue)}
                  alt={venue.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="eager"
                  onError={(e) => {
                    const img = e.target as HTMLImageElement;
                    img.src = '/assets/images/placeholder.webp';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-semibold text-white mb-2">
                    {venue.name}
                  </h3>
                  <p className="text-lg text-[#d0b286]">
                    {[venue.country, venue.area, venue.city].filter(Boolean).join(', ')}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Gradient overlays */}
      <div className="absolute left-0 top-0 bottom-0 w-40 bg-gradient-to-r from-[#171b20] to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-40 bg-gradient-to-l from-[#171b20] to-transparent z-10" />
    </div>
  );
}; 